import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setGlobalCurrentStep } from "../../redux/slices/abhaSlice";
const PerferredAbhaOptions = ({
  setAdharNumber,
  setSendOtpFunction,
  setPatient1,
  setCurrentStep,
}) => {
  const dispatch = useDispatch();
  const [preferredAbhaAddress, setPreferredAbhaAddress] = useState("");
  const [abhaNumber, setAbhaNumber] = useState("");

  useEffect(() => {
    const storedAbhaAddress = localStorage.getItem("preferredAbhaAddress");
    const storedAbhaNumber = localStorage.getItem("preferredAbhaNumber");
    console.log("storedAbhaNumber", storedAbhaNumber);
    if (storedAbhaAddress) {;
      setPreferredAbhaAddress(storedAbhaAddress);
    } else {
      setCurrentStep("AbhaSuggestions");
    }
    if (storedAbhaNumber) setAbhaNumber(storedAbhaNumber);
  }, []);

  const handleContinue = () => {
    setCurrentStep("AbhaCard");
    localStorage.setItem("existingAbha", "true");
  };

  const handleCreateNew = () => {
    setCurrentStep("AbhaSuggestions");
  };
  // console.log("Try programiz.pro");
  const masked = abhaNumber.replace(
    /^(\d{2})-(?:\d{4})-(?:\d{4})-(\d{4})$/,
    "$1-xxxx-xxxx-$2"
  );
  return (
    <>
      <section className="container">
        <div className="abha-create-steps">
          <div className="row">
            <div className="col-md-6">
              <div className="create-abha">
                <h2>Create ABHA Number in 3 Steps</h2>
                <p>
                  Create ABHA and store all your medical records in one place.
                  Take part in the{" "}
                  <span className="highlight">
                    Ayushman Bharat Digital Mission (ABDM)
                  </span>{" "}
                  and get started on your digital health journey.
                </p>

                {/* Steps */}
                <div className="vertical-steps">
                  <div className="step-item">
                    <div className="step-marker">1</div>
                    <div className="step-content">
                      <h4>Verify Aadhaar Details</h4>
                      <p>
                        Enter your Aadhaar number and verify with OTP received
                        on Aadhaar linked mobile number.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">2</div>
                    <div className="step-content">
                      <h4>Link Mobile Number</h4>
                      <p>
                        Enter your mobile number and verify with OTP to link
                        with ABHA .
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">3</div>
                    <div className="step-content">
                      <h4>Create ABHA</h4>
                      <p>Create your ABHA Number with a unique ABHA .</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Form Card */}
            <div className="col-md-6">
              <div className="form-card content">
                <p className="text-center">
                  We found that you already have Preferred ABHA address
                  associated with <br />
                  ABHA Number <strong>{masked}</strong>
                </p>

                <div className="text-center mt-3">
                  <input
                    type="text"
                    className="form-control text-center"
                    value={preferredAbhaAddress}
                    readOnly
                    autoComplete="off"
                  />
                </div>

                <div className="text-center mt-4">
                  <button
                    className="continue-btn mt-1"
                    onClick={handleContinue}
                  >
                    Continue
                  </button>
                </div>

                <div className="text-center mt-3">
                  <p>
                    Or{" "}
                    <span
                      className="resend-message cursor-pointer"
                      onClick={handleCreateNew}
                    >
                      Still want to create ABHA address
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PerferredAbhaOptions;
